import type { PropsWithChildren } from "react";
import { Grid as ReshapedGrid } from "reshaped";

type GridProps = PropsWithChildren<{
    columns: number;
    gap?: number;
}>;

export default function Grid(props: GridProps) {
    const { columns, gap = 1 } = props;
    return (
        <ReshapedGrid columns={columns} gap={gap}>
            {props.children}
        </ReshapedGrid>
    );
}

type GridColspanProps = PropsWithChildren<{
    columns: number;
}>;

export function GridColspan(props: GridColspanProps) {
    const { columns } = props;
    return <ReshapedGrid.Item colSpan={columns}>{props.children}</ReshapedGrid.Item>;
}
